module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/426.add0ea2b.png";